export function getUserLocales() {
    // We need to use a Regex, because some chrome versions return "en;0.5" or
    // "en-US,en;q=0.9" as the first element in navigator.languages, which is not a
    // valid locale. We only care about English locales, so we
    // filter out any non-english locales, and add a default en-US in case there is no other english locale
    return [...navigator.languages.filter(locale => /^en(-\w{2})?$/.exec(locale)), "en-US"];
}
